import { render, staticRenderFns } from "./createAgent.vue?vue&type=template&id=af4e3b22&scoped=true&"
import script from "./createAgent.vue?vue&type=script&lang=js&"
export * from "./createAgent.vue?vue&type=script&lang=js&"
import style0 from "./createAgent.vue?vue&type=style&index=0&id=af4e3b22&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4e3b22",
  null
  
)

export default component.exports